var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ypdxi9i9ja",
    x1: "100%",
    x2: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffa91d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fa631d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u868npeqtb",
    x1: "100%",
    x2: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffa91d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fa631d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1138 -513) translate(1138 513)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    x: 0.5,
    y: 0.5,
    stroke: "url(#ypdxi9i9ja)",
    rx: 13.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u868npeqtb)",
    fillRule: "nonzero",
    d: "M19.75 12H8.25C7.56 12 7 12.672 7 13.5S7.56 15 8.25 15h11.5c.69 0 1.25-.672 1.25-1.5s-.56-1.5-1.25-1.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.11e17cdb71181b61bd2a0b5fb1f50b11.svg";
export { ForwardRef as ReactComponent };